/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type UpdateHardwareItemRequestQuantityMutationVariables = Types.Exact<{
  id: Types.Scalars["Float"];
  quantity: Types.Scalars["Float"];
}>;

export type UpdateHardwareItemRequestQuantityMutation = {
  updateHardwareItemRequestQuantity: Pick<
    Types.HardwareItemRequest,
    "id" | "quantity" | "hardware_item_id" | "hardware_request_id"
  >;
};

export const UpdateHardwareItemRequestQuantityDocument = gql`
  mutation UpdateHardwareItemRequestQuantity($id: Float!, $quantity: Float!) {
    updateHardwareItemRequestQuantity(id: $id, quantity: $quantity) {
      id
      quantity
      hardware_item_id
      hardware_request_id
    }
  }
`;

/**
 * __useUpdateHardwareItemRequestQuantityMutation__
 *
 * To run a mutation, you first call `useUpdateHardwareItemRequestQuantityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHardwareItemRequestQuantityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHardwareItemRequestQuantityMutation, { data, loading, error }] = useUpdateHardwareItemRequestQuantityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useUpdateHardwareItemRequestQuantityMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateHardwareItemRequestQuantityMutation,
    UpdateHardwareItemRequestQuantityMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    UpdateHardwareItemRequestQuantityMutation,
    UpdateHardwareItemRequestQuantityMutationVariables
  >(UpdateHardwareItemRequestQuantityDocument, baseOptions);
}
export type UpdateHardwareItemRequestQuantityMutationHookResult = ReturnType<
  typeof useUpdateHardwareItemRequestQuantityMutation
>;
export type UpdateHardwareItemRequestQuantityMutationResult =
  ApolloReactCommon.MutationResult<UpdateHardwareItemRequestQuantityMutation>;
export type UpdateHardwareItemRequestQuantityMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateHardwareItemRequestQuantityMutation,
    UpdateHardwareItemRequestQuantityMutationVariables
  >;
